import React from "react";

import {
  MinimumPay as CoreMinimumPay,
  type SalaryPreference,
} from "../../../../../../../../../../shared/components/MinimumPay";

// Re-export the shared SalaryPreference so existing consumers keep resolving after the convergence.
export type { SalaryPreference };

interface MinimumPayProps {
  value?: SalaryPreference;
  onChange: (salaryPreference: SalaryPreference) => void;
  showErrors?: boolean;
}

/**
 * ViewJob's minimum pay form — the shared `MinimumPay` body; the old local impl and its
 * `JmRnReusablePayComponentTst` gate were removed.
 */
export const MinimumPayForm: React.FC<MinimumPayProps> = ({ value, onChange, showErrors }) => (
  <CoreMinimumPay
    value={value}
    onChange={onChange}
    showErrors={showErrors}
    showEmployerAlert={true}
    variant="default"
  />
);
